import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { usePathname } from "next/navigation";
import { Fragment, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
type props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  children?: React.ReactNode;
  title?: React.ReactNode;
};

export default function LeftDrawer({ open, setOpen, children, title }: props) {
  const pathname = usePathname();

  useEffect(() => {
    setOpen(false);
  }, [pathname, setOpen]);

  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpen}>
        <div className="fixed inset-0" />
        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 left-0 flex max-w-full">
              <TransitionChild
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <DialogPanel className="pointer-events-auto w-screen max-w-md">
                  <div className="h-full bg-gray-900 shadow-xl pt-14">
                    <div className="px-4 sm:px-6 h-14 top-0 absolute w-full">
                      <div className="flex items-start justify-between mt-4">
                        {/* <DialogTitle className="text-base font-semibold leading-6 text-gray-900"></DialogTitle> */}
                        {title}
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            tabIndex={-1}
                            className="relative rounded-md text-white hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => setOpen(false)}
                          >
                            <span className="absolute -inset-2.5" />
                            <span className="sr-only">Close panel</span>
                            <IoMdClose className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="relative py-4 px-4 sm:px-6 h-full overflow-y-scroll">
                      {children}
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
